import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/site/ServiceDetail";
import office from "@/assets/service-office.webp";

export const Route = createFileRoute("/services/commercial")({
  head: () => ({
    meta: [
      { title: "Commercial & Office Cleaning in Salisbury Plain | IZHUB" },
      { name: "description", content: "Reliable commercial and office cleaning across Tidworth, Andover and Salisbury. Regular scheduled visits or one-off deep cleans for offices, clinics, salons and studios." },
      { property: "og:title", content: "Commercial & Office Cleaning | IZHUB Cleaning Services" },
      { property: "og:description", content: "Discreet, reliable cleaning for offices, coworking spaces, clinics, salons and studios — in-hours or out-of-hours." },
      { property: "og:url", content: "https://izhubcleaning.uk/services/commercial" },
    ],
    links: [{ rel: "canonical", href: "https://izhubcleaning.uk/services/commercial" }],
  }),
  component: CommercialPage,
});

function CommercialPage() {
  return (
    <ServiceDetail
      data={{
        title: "Commercial & Office Cleaning",
        heroTitle: <>A cleaner workplace, <span className="rainbow-text">zero hassle</span>.</>,
        intro: "Reliable, discreet commercial and office cleaning across Tidworth, Andover and Salisbury — regular scheduled visits or one-off deep cleans.",
        image: office,
        imageAlt: "A clean, modern office workspace",
        forWho: "Small offices, coworking spaces, clinics, salons, studios.",
        quoteService: "commercial",
        includes: [
          "Desks, meeting rooms, kitchens and washrooms",
          "Waste, recycling and consumable restock",
          "Out-of-hours or in-hours to suit your team",
          "Regular scheduled visits or one-off deep cleans",
          "Vetted, insured and uniformed cleaners",
          "Simple monthly invoicing for businesses",
        ],
        paragraphs: [
          "A clean workplace matters — for your team's wellbeing, for clients who visit, and for the impression your business makes every day. Our commercial cleaning service covers offices, coworking spaces, clinics, salons and studios across Salisbury Plain.",
          "We work around your business: early mornings, evenings or weekends, in-hours or out-of-hours. Visits are scheduled and consistent, with the same vetted, insured cleaners wherever possible, and simple monthly invoicing.",
          "From a small office needing a weekly visit to a premises that needs a full deep clean, get an instant estimate online or message us on WhatsApp to arrange a walkthrough.",
        ],
      }}
    />
  );
}
